import { inspectionActions } from '@redux/slices/inspection';
import { checkOldAndNewArray } from '@services/check-old-and-new-array';
import { getAppDispatch } from '@utilities/dispatch.util';
import { store } from 'redux/store';

const inspectionForManipulationJson = ({ initialLogin, isSettingUpdated, data }) => {
  const { inspection } = store.getState();

  const items = data || [];
  let inspectionForRes = [];
  if (!initialLogin && inspection?.inspectionFormsUserCache?.length && !isSettingUpdated) {
    const combineNewAndOldArray = checkOldAndNewArray({
      oldArray: inspection?.inspectionFormsUserCache,
      oldArrayMap: inspection?.inspectionFormsUserCacheMap,
      newArray: items,
      idName: 'inspectionFormId'
    });

    inspectionForRes = combineNewAndOldArray;
  } else {
    if (items?.length > 0) inspectionForRes = items;
  }

  const inspectionFormsUserCache = inspectionForRes || [];
  const inspectionFormsUserCacheMap = inspectionFormsUserCache?.reduce((acc, curr) => {
    acc[curr.inspectionFormId] = {
      quickComplete: curr?.quickComplete,
      failureCriteria: curr?.failureCriteria,
      name: curr?.name,
      inspectionFormId: curr?.inspectionFormId,
      inspectionType: curr?.inspectionType
    };
    return acc;
  }, {});

  const inspectionFormsUserCacheTypeMap = inspectionFormsUserCache?.reduce((acc, curr) => {
    acc[curr.inspectionType] = {
      name: curr?.name
    };
    return acc;
  }, {});

  return {
    inspectionFormsUserCache,
    inspectionFormsUserCacheMap,
    inspectionFormsUserCacheTypeMap
  };
};

const inspectionFormDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    inspectionActions.setInspectionFormsUserCache({
      inspectionFormsUserCache: data?.inspectionFormsUserCache,
      inspectionFormsUserCacheMap: data?.inspectionFormsUserCacheMap,
      inspectionFormsUserCacheTypeMap: data?.inspectionFormsUserCacheTypeMap
    })
  );
};

const equipmentFormManipulationJson = ({ data }) => {
  const equipmentFormsUserCache = data || [];

  const equipmentFormsUserCacheMap = equipmentFormsUserCache?.reduce((acc, curr) => {
    acc[curr.id] = { ...curr };
    return acc;
  }, {});
  return {
    equipmentFormsUserCache,
    equipmentFormsUserCacheMap
  };
};

const equipmentFormDispatcher = ({ data }) => {
  const dispatch = getAppDispatch();

  dispatch?.(
    inspectionActions.setEquipmentFormsUserCache({
      equipmentFormsUserCache: data?.equipmentFormsUserCache,
      equipmentFormsUserCacheMap: data?.equipmentFormsUserCacheMap
    })
  );
};

export {
  inspectionForManipulationJson,
  inspectionFormDispatcher,
  equipmentFormManipulationJson,
  equipmentFormDispatcher
};
